import React from "react";

// region Imports - Components
import ButtonLoading from "@components/Button/ButtonLoading";

import UserPersonalData from "../molecules/UserPersonalData";
import UserAccessControl from "../molecules/UserAccessControl";
import UserPermissions from "../molecules/UserPermissions";
import UserVehicleRestrictions from "../molecules/UserVehicleRestrictions";
// endregion Imports - Components
// region Imports - External libraries
import { Form } from "@unform/web";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Grid, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
// endregion Imports - External libraries
// region Imports - Languages
import { ManagementMessages, GlobalMessages } from "@shared/languages/interfaces";
// endregion Imports - Languages
// region Imports - Shared / Utils
import { Regional } from "@shared/interfaces/regional.interface";
import { Plant } from "@shared/entities/reg_plants.entity";
import { User } from "@shared/interfaces/user.interface";
import { TpeAlertWithFunctionality } from "../../types";
// endregion Imports - Shared / Utils

interface UserFormModalProps {
  t: (key: string) => string;
  modalType: "details" | "update" | "register";
  userDetails: User;
  loggedUser: any;
  setModalType: (type: "details" | "update" | "register") => void;
  openModalFormUser: boolean;
  handleCloseModalForm: () => void;
  formRef: any;
  validateForm: (data: any, type: any) => void;
  loadingResendConfirmAccountMail: boolean;
  resendConfirmAccountMail: () => void;
  defineValueAccordingModalType: (d: any, u: any, r: any) => any;

  // UserPersonalData
  loadingValidateFieldEmail: boolean;
  activeCheckbox: boolean;
  setActiveCheckbox: (val: boolean) => void;
  dailyReportCheckbox: boolean;
  setDailyReportCheckbox: (val: boolean) => void;
  weeklyReportCheckbox: boolean;
  setWeeklyReportCheckbox: (val: boolean) => void;
  dailyCanReportCheckbox: boolean;
  setDailyCanReportCheckbox: (val: boolean) => void;
  weeklyCanReportCheckbox: boolean;
  setWeeklyCanReportCheckbox: (val: boolean) => void;
  adminCheckbox: boolean;
  setAdminCheckbox: (val: boolean) => void;
  validateEmail: (email: string) => void;
  getHelperTextToTelegram: () => string;
  screenPlatform: string;

  // UserAccessControl
  loadingOptionsRegionals: boolean;
  loadingOptionsPlants: boolean;
  activeOptionsRegionals: Regional[];
  optionsRegionals: Regional[];
  handleChangeRegional: (value: Regional[]) => void;
  openOptionsRegionals: boolean;
  setOpenOptionsRegionals: (open: boolean) => void;
  activeOptionsPlants: Plant[];
  optionsPlants: Plant[];
  handleChangePlants: (value: Plant[]) => void;
  openOptionsPlants: boolean;
  setOpenOptionsPlants: (open: boolean) => void;
  checkAllPlants: boolean;
  handleCheckAllPlantsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;

  // UserPermissions
  loadingOptionsPermissions: boolean;
  activeOptionsPermissions: TpeAlertWithFunctionality[];
  optionsPermissions: TpeAlertWithFunctionality[];
  openOptionsPermissions: boolean;
  setOpenOptionsPermissions: (open: boolean) => void;
  setActiveOptionsPermissions: (permissions: TpeAlertWithFunctionality[]) => void;
  checkAllPermissions: boolean;
  setCheckAllPermissions: (check: boolean) => void;
  handleCheckAllPermissionsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;

  // UserVehicleRestrictions
  activeRestrictVehicleIds: string[];
  setActiveRestrictVehicleIds: (ids: string[]) => void;
  optionsRestrictVehicles: any[];
  setActiveRestrictVehicles: (vehicles: any[]) => void;
  formattedRestrictVehicleOptions: any[];
  dualListboxLang: any;
}
const UserFormModal: React.FC<UserFormModalProps> = (props) => {
  const {
    t,
    modalType,
    userDetails,
    loggedUser,
    setModalType,
    openModalFormUser,
    handleCloseModalForm,
    formRef,
    validateForm,
    loadingResendConfirmAccountMail,
    resendConfirmAccountMail,
    defineValueAccordingModalType
  } = props;

  return (
    <Dialog
      open={openModalFormUser}
      onClose={handleCloseModalForm}
      scroll="paper"
      container={document.getElementById("modalFormUser")}
    >
      <DialogTitle className="mHeader">
        <div className="content">
          <div className="title">
            {defineValueAccordingModalType(userDetails.name, userDetails.name, t(ManagementMessages.detailsHeaderRegister))}
          </div>
          <div className="subtitle">
            {defineValueAccordingModalType(userDetails.email, userDetails.email, "")}
          </div>
        </div>
        <div className="actions">
          {modalType === "details" && (loggedUser.super_admin || !userDetails.super_admin) && (
            <Button disableRipple onClick={() => setModalType("update")}>
              <EditIcon />
            </Button>
          )}
        </div>
      </DialogTitle>
      <DialogContent dividers className="mContent">
        <Form
          className="form"
          ref={formRef}
          onSubmit={(formData) => validateForm(formData, modalType)}
        >
          <DialogContentText tabIndex={-1} component="div">
            <Grid container spacing={1}>
              <UserPersonalData {...props} />
              <UserAccessControl {...props} />
              <UserPermissions {...props} />
              <UserVehicleRestrictions {...props} />
            </Grid>
          </DialogContentText>
        </Form>
        {modalType !== "register" && (
          <ButtonLoading
            className="btnResendMail"
            loading={loadingResendConfirmAccountMail}
            loadingContent="Reenviando email..."
            onClick={() => resendConfirmAccountMail()}
          >
            {t(ManagementMessages.detailsResendEmail)}
          </ButtonLoading>
        )}
      </DialogContent>
      <DialogActions className="mFooter">
        <div className="actions">
          {
            modalType === "details"
              ? <></>
              : modalType === "register"
                ? (
                  <Button
                    disableRipple
                    type="submit"
                    color="primary"
                    onClick={() => formRef.current?.submitForm()}
                  >{t(GlobalMessages.register)}
                  </Button>
                )
                : (
                  <Button
                    disableRipple
                    type="submit"
                    color="primary"
                    onClick={() => formRef.current?.submitForm()}
                  >{t(GlobalMessages.save)}
                  </Button>
                )
          }
        </div>
        <Button disableRipple onClick={() => handleCloseModalForm()} color="primary">{t(GlobalMessages.close)}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserFormModal;
